import { render, staticRenderFns } from "./ReportDetailsModal.vue?vue&type=template&id=a0bf9f18&scoped=true&"
import script from "./ReportDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailsModal.vue?vue&type=style&index=0&id=a0bf9f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf9f18",
  null
  
)

export default component.exports